import React from "react";
import { Link, useParams } from "react-router-dom";

import SectionHeader from "../../components/SectionHeader";
import { Table } from "../../../../../../components/Functional";
import { FETCH_ITEMS_V2 as fetchItemsV2 } from "../../../../../../graphql/query/Item";
import { formatInvoiceReference } from "../../../../../../util/formatInvoiceReference";

const InstanceSales = props => {
  const { id: instanceId } = useParams();

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "itemsV2",
    headers: [
      {
        label: "Client",
        name: "invoice.contact.name",
        type: "custom",
        component: props => {
          const invoice = props?.values?.invoice;
          const contactName = invoice?.contact?.name || "";
          const companyName = invoice?.companyName || "";
          const value = [
            contactName,
            companyName && contactName ? `(${companyName})` : companyName,
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <Link
              className="underline"
              to={`/contacts/${invoice?.contact?.id}/details`}
            >
              {value}
            </Link>
          );
        },
      },
      {
        label: "Invoice/Proforma",
        name: "invoice.reference",
        type: "custom",
        component: props => (
          <Link
            className="underline"
            to={`/invoice/${props?.values?.invoice?.id}/details`}
          >
            {formatInvoiceReference(props?.values?.invoice)}
          </Link>
        ),
      },
      {
        label: "Amount",
        type: "custom",
        component: props => (
          <span className="flex gap-1">
            <span className="overflow-hidden text-ellipsis text-base font-medium leading-5 text-black">
              {`${(
                props?.values?.amount - props?.values?.discount
              )?.toLocaleString("en-US")} ${
                props?.values?.invoice?.currency?.code
              }`}
            </span>
          </span>
        ),
      },
      { label: "Date", name: "date", type: "date-numeric" },
      { label: "Due", name: "invoice.dueDate", type: "date" },
      { label: "Certificate", name: "instance.certificate", type: "label" },
    ],
    inputs: [],
    FETCH_QUERY: fetchItemsV2({
      instance: {
        certificate: true,
      },
      invoice: {
        contact: {
          name: true,
          company: true,
        },
        currency: {
          code: true,
        },
      },
    }),
    variables: {
      instanceId: {
        value: instanceId,
        operator: "eq",
      },
    },
    className: "sm:px-0 lg:px-0",
  };

  return (
    <div className="w-full">
      <SectionHeader title="Sales" />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default InstanceSales;
